import Vue from "vue";
import App from "./App.vue";
import store from "@/store";

Vue.config.productionTip = false;

// 在body中添加一个div元素，id为chatbox
const chatbox = document.createElement("div");
chatbox.id = "chatbox";
document.body.appendChild(chatbox);

// const script = document.createElement("script");
// script.src = "https://aicustservice-gpt4.de.r.appspot.com/static/js/chatbox.js";
// document.head.appendChild(script);

new Vue({
  store,
  render: (h) => h(App),
}).$mount("#chatbox");
